import { Routes } from '@angular/router';
import { RoutesApp } from './models/enums/routes-app.enum';
import { AuthGuard } from './guards/auth.guard';
import { StudentAuthGuard } from './guards/student-auth.guard';
import { FeaturePreferenceGuard } from './guards/feature-preference.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  // Root redirect
  {
    path: RoutesApp.ROOT,
    redirectTo: RoutesApp.SPLASH,
    pathMatch: 'full',
  },
  
  // === SPLASH SCREEN ===
  {
    path: RoutesApp.SPLASH,
    loadComponent: () => import('./splash/splash.page').then(m => m.SplashPage)
  },
  
  // === AUTHENTICATION ROUTES (Public) ===
  {
    path: RoutesApp.USER_TYPE_SELECTION,
    loadComponent: () => import('./user-type-selection/user-type-selection.page').then( m => m.UserTypeSelectionPage),
    canActivate: [GuestGuard]
  },
  {
    path: RoutesApp.AUTH,
    loadComponent: () => import('./auth/auth.page').then((m) => m.AuthPage),
  },
  {
    path: 'auth/login',
    loadComponent: () => import('./auth/login/login.page').then((m) => m.UnifiedLoginPage),
    canActivate: [GuestGuard]
  },
  {
    path: 'auth/reset-password',
    loadComponent: () =>
      import('./auth/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
  },
  {
    path: 'auth/sms-verification',
    redirectTo: 'auth/login',
    pathMatch: 'full',
  },
  {
    path: RoutesApp.REGISTER,
    loadComponent: () => import('./auth/register.page').then((m) => m.RegisterPage),
    canActivate: [GuestGuard]
  },
  
  // === STUDENT WELCOME (Public - before authentication) ===
  {
    path: 'student/welcome',
    loadComponent: () => import('./student/welcome/welcome.page').then((m) => m.WelcomePage),
    canActivate: [GuestGuard]
  },
  
  // === STUDENT MODULE ROUTES (Lazy Loaded - requires StudentAuthGuard) ===
  {
    path: 'student',
    loadChildren: () => import('./student/student.routes').then(m => m.STUDENT_ROUTES),
    canActivate: [StudentAuthGuard],
    canActivateChild: [FeaturePreferenceGuard]
  },
  
  // === SHARED ROUTES (Private - requires AuthGuard) ===
  {
    path: RoutesApp.CHAT,
    loadComponent: () => import('./chat/chat.page').then((m) => m.ChatPage),
    canActivate: [AuthGuard, FeaturePreferenceGuard]
  },
  {
    path: RoutesApp.CHAT_LIST,
    loadComponent: () => import('./chat-list/chat-list.page').then((m) => m.ChatListPage),
    canActivate: [AuthGuard, FeaturePreferenceGuard]
  },
  {
    path: RoutesApp.NOTIFICATIONS,
    loadComponent: () => import('./notifications').then((m) => m.NotificationsPage),
    canActivate: [AuthGuard]
  },
  {
    path: RoutesApp.AI_CHAT,
    redirectTo: `${RoutesApp.CHAT}?chatId=ai-chat`,
    pathMatch: 'full'
  },
  {
    // Campanha de indicação (aluno e personal)
    path: 'referral',
    loadComponent: () => import('./referral/referral.page').then((m) => m.ReferralPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'contact',
    loadComponent: () => import('./contact/contact.page').then((m) => m.ContactPage),
    canActivate: [AuthGuard]
  },
  {
    path: 'terms-of-use',
    // Público: quem está se cadastrando precisa ler o que vai aceitar
    loadComponent: () => import('./terms-of-use/terms-of-use.page').then((m) => m.TermsOfUsePage),
  },
  
  // === TRAINER MODULE ROUTES (Lazy Loaded) ===
  {
    path: 'trainer',
    loadChildren: () => import('./trainer/trainer.routes').then(m => m.TRAINER_ROUTES),
    canActivateChild: [FeaturePreferenceGuard]
  }
];
